import React, { useState, useEffect } from 'react';
import {Subject} from 'rxjs';

let channels = {
  default: new Subject(),
};

const useReactiveMessage = (channel = 'default') => {

  useEffect(() => {
    if (!channels[channel]) {
      channels[channel] = new Subject();
    }
  }, []);

  return {
    sendMessage: (message, _channel) => channels[_channel?_channel:channel].next({ ...message }),
    clearMessages: () => channels[channel].next(),
    getMessage: () => channels[channel].asObservable()
  };
};

export default useReactiveMessage;
